export default () => ({
  dates: [],
  visit: {},
  userInfo: {
    document: '',
    phoneNumber: '',
  },
})
